import React from "react";
import i18n from "../i18n";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error("App render error:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen grain flex flex-col items-center justify-center gap-4 px-8 text-center" data-testid="app-error-boundary">
          <p className="text-white/70 text-sm">{i18n.t("common.error_page")}</p>
          <button onClick={() => { this.setState({ hasError: false }); window.location.href = "/"; }}
            className="px-5 py-2.5 rounded-full bg-gold text-black text-sm font-bold" data-testid="app-error-home">
            {i18n.t("common.back_home")}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
